import { createContext } from 'react'

import { registerSharedDependency } from 'core-components/helpers/MFHelper'

import { IKeyboardContextValue, IKeyboardEvent } from './models'

const KeyboardContextLocal = createContext<IKeyboardContextValue>({
  registr: (pressHandler: Array<IKeyboardEvent>) => {
    console.error('KeyboardContext.registr must be a function')
    return {
      priorifize: () => undefined,
      unregistr: () => undefined,
    }
  },
})

export const KeyboardContext = registerSharedDependency<typeof KeyboardContextLocal>(
  'KeyboardContext',
  () => KeyboardContextLocal
)
